import React from 'react';
import TrulyInboxIcon from '../../../../svg/main-logo/trulyInboxIcon';
import './gradient-loader.scss';

const GradientLoader: React.FC = () => (
  <div className="gradient-loader-container">
    <div className="gradient-loader">
      <svg className="gradient-loader-svg" viewBox="0 0 136 136">
        <defs>
          <linearGradient
            id="gradient-loader-gradient"
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
          >
            <stop offset="0%" stopColor="#FD853A" />
            <stop offset="100%" stopColor="#FB6414" />
          </linearGradient>
        </defs>
        <circle
          className="gradient-loader-circle"
          cx="68"
          cy="68"
          r="66"
          fill="none"
          stroke="url(#gradient-loader-gradient)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="370"
          strokeDashoffset="92"
        />
      </svg>
      <div className="gradient-loader-icon">
        <TrulyInboxIcon width={64} height={64} />
      </div>
    </div>
  </div>
);

export default GradientLoader;
